import React, { useState } from 'react';
import {  Image,  Keyboard } from 'react-native';
import OTPVerification from '@sharedComponents/OTPInput/OTPInput';
import axios from 'axios';
import { X } from '@sharedComponents/Icons';
import {useDarkMode} from '@app/utils';
import { ThemedPressable, ThemedText, ThemedView } from '@app/theme';
import { useDispatch } from 'react-redux';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import handleApiErr from '@app/helper/handleApiErr';
import { handleOtpReport } from '@app/screens/FetchPortfolio/utils';
import ReportOtp from '../../../assets/Icons/ReportOtp';
import Button from '../Button/Button';

const phoneUrl = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder_msg.png'
const emailUrl = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder.png'
interface ConfirmWithdrawOTP {
  heading?: string;
  otpType?: string;
  otpSentTo: string;
  otpSentToSecondaryDetails?: string;
  verifyUrl:string;
  resendUrl: string;
  apiPayload?: Object;
  otpDigitCount: number;
  attributeKeyToVerify: string;
  attributeValueToVerify?: string;
  onClose: () => void;
  onVerificationSuccess: (data?:any) => void;
  onVerificationFailure?: (error?: any) => void;
  resendApiMethod?: 'GET' | 'POST';
  isErrorReceived?: () => void;
  currentStep? : string,
  uniqueIdentifier ? : string



}

const VerificationOTP: React.FC<ConfirmWithdrawOTP> = ({
  otpDigitCount,
  heading=`Enter ${otpDigitCount}-digit OTP`,
  otpType='PHONE_NUMBER',
  otpSentTo,
  otpSentToSecondaryDetails,
  verifyUrl,
  resendUrl,
  apiPayload,
  attributeKeyToVerify,
  attributeValueToVerify,
  onClose,
  onVerificationSuccess,
  onVerificationFailure,
  resendApiMethod='POST',
  isErrorReceived,
  uniqueIdentifier,
  currentStep
}) => {
  const [hasError, setHasError] = useState<string>('');
  const [verifying, setVerifying] = useState<boolean>(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [isReportingMode,setIsReportingMode] = useState(false);
  const isDarkMode = useDarkMode();
  const dispatch = useDispatch();
  const submitOtp = (otp: string) => {
    setVerifying(true);
    const payload = {
      [attributeKeyToVerify]: attributeValueToVerify,
      otp,
    };
    axios
      .post(verifyUrl, payload)
      .then(res => {
        onVerificationSuccess(res?.data);
        onClose();
      })
      .catch(err => {
        console.log('submitOtperr', err);
        if(onVerificationFailure){
          onVerificationFailure(err);
        }
        setHasError(err?.data?.message);
        if (
          err?.status === 400 &&
          err?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP'
        ) {
          setIsBlocked(true);
        }
      })
      .finally(() => {
        setVerifying(false);
      });
  };

  const handleOtpInput = (otp: string[]) => {
    if (isBlocked) {
      return;
    }

    const OTP = otp.join('');
    if (OTP.length === otpDigitCount) {
      submitOtp(OTP);
    } else if (OTP.length > 0 && hasError !== '') {
      setHasError('');
    }
  };

  const reportOtpIssue = async () => {
    handleOtpReport({
     payload: {
         uniqueId:uniqueIdentifier ,
         uniqueIdentifierType: currentStep,
     }, 

 })
 }

  const triggerResendOTP = (): void => {
    setHasError('');
    const resendtOtp = resendApiMethod === 'GET' ? axios.get(resendUrl) : axios.post(resendUrl, apiPayload);
    resendtOtp
      .then(res => {
        console.log('senOTP', res);
      })
      .catch(err => {
        setHasError(err?.message);
        console.log('error', err);
        if (
         handleApiErr(err)
        ) {
          setIsBlocked(true);
          Keyboard.dismiss();
        isErrorReceived &&   isErrorReceived()
          onClose();
         
         
          setTimeout(() => {
            dispatch(
              showErrorSheet({
                isErrorSheetVisible: true,
                errorMessage: err?.data?.message,
                closeOnBackdropPress: true,
                errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                errorHeading: err?.data?.header,
                showErrorHeading: true,
              }));
          },1000)
     
        }
      });
  };

  return isReportingMode? (<>
    <ThemedView alignItems='center' padding='lg'>
     <ReportOtp width={100} height={100}/>
     <ThemedText variant='h5s'>Request Received</ThemedText>
   <ThemedText textAlign='center' marginTop='sm' variant='b3r'>
   {"Thanks for the feedback, We are working on the issue, please try again shortly."}    </ThemedText>

       <Button handlePress={()=>{
         onClose()
         setTimeout(()=>{
           setIsReportingMode(false)

         },1000)
         
       }}
       overRideStyle={{marginTop:24}}
       label='Got it'
       />
     </ThemedView>
 
 </>) : (
    <>
      <ThemedView p="lg" mt="sm">
        <ThemedView flexDirection='row' justifyContent='space-between'>
          <ThemedView mb="lg">
            <ThemedText variant='h3b' color='text-primary' >{heading}</ThemedText>
          </ThemedView>
          {/* <ThemedPressable onPress={onClose}>
            <X size={24} color={isDarkMode?'#fff':'#000'}/>
          </ThemedPressable> */}
        </ThemedView>
        {otpType==="PHONE_AND_EMAIL" ? (
          <ThemedView flexDirection='row'
            borderRadius='md'
            borderWidth={1}
            borderColor='border-emphasis-secondary'
            p="md"
            backgroundColor='bg-fill-emphasis-secondary'
            mb="lg"
          >
          <ThemedView>
            <ThemedText color='text-secondary' variant='b3r'>
                OTP sent to
            </ThemedText>
            <ThemedView flexDirection='row' py="sm" alignItems='center'>
              <Image source={{ uri: phoneUrl }} style={{ width: 40, height: 40 }} />
              <ThemedView ml="md">
                  <ThemedText color='text-primary' variant='b3m' style={{wordBreak:'break-all'}}>
                      {`+91 ${otpSentTo?.length>10 ? otpSentTo.slice(3):otpSentTo}`}
                  </ThemedText>
                  <ThemedView style={{marginTop:3}}>
                  </ThemedView>
              </ThemedView>
            </ThemedView>
            <ThemedView flexDirection='row' alignItems='center'>
              <Image source={{ uri: emailUrl }} style={{ width: 40, height: 40 }} />
              <ThemedView ml="md">
                  <ThemedText color='text-primary' variant='b3m' style={{wordBreak:'break-all'}}>
                      { otpSentToSecondaryDetails }
                  </ThemedText>
                  <ThemedView style={{marginTop:3}}>
                  </ThemedView>
              </ThemedView>
            </ThemedView>
            
          </ThemedView>
        </ThemedView>
        ):(
          <ThemedView flexDirection='row'
            borderRadius='md'
            borderWidth={1}
            borderColor='border-emphasis-secondary'
            p="md"
            backgroundColor='bg-fill-emphasis-secondary'
            mb="lg"
          >
          <Image source={{ uri: otpType==="PHONE_NUMBER" ? phoneUrl:emailUrl }} style={{ width: 40, height: 40 }} />
          <ThemedView ml="md" flex={1} flexWrap='wrap'>
            <ThemedText color='text-secondary' variant='b4r'>
                  OTP was sent to
              </ThemedText>
              <ThemedText color='text-primary' variant='b3m' style={{wordBreak:'break-all'}}>
                  {otpType==="PHONE_NUMBER" ? `+91 ${otpSentTo?.length>10 ? otpSentTo.slice(3):otpSentTo}`:otpType==="EMAIL"? otpSentTo :attributeValueToVerify}
              </ThemedText>
              <ThemedView style={{marginTop:3}}>
              </ThemedView>
          </ThemedView>
        </ThemedView>)}
        <OTPVerification
          noOfDigits={otpDigitCount}
          hasError={hasError}
          handleOtpInput={handleOtpInput}
          resendTimerCount={15}
          triggerResendOTP={triggerResendOTP}
          verifying={verifying}
          blockResend={isBlocked}
          onCustomerFacingIssue={() => {
           setIsReportingMode(true)
           reportOtpIssue();
          }
        }
          isDarkMode={Boolean(isDarkMode)}
        />
      </ThemedView>
    </>
  );
};
export default VerificationOTP;
